'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleTooltipBoxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

/** PROP RECEIVERS */
var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.toggleButton.label,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      size = 'calc(' + (0, _reactackleCore.getValueString)(fontSize) + ' * ' + lineHeight + ')';


  return '\n    height: ' + size + ';\n  ';
};

/** STYLES */
var ToggleTooltipBoxStyled = exports.ToggleTooltipBoxStyled = _styledComponents2.default.span.withConfig({
  displayName: 'ToggleTooltipBoxStyled'
})(['display:flex;align-items:center;', ';'], baseProps);

ToggleTooltipBoxStyled.propTypes = propTypes;
ToggleTooltipBoxStyled.displayName = 'ToggleTooltipBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-toggle-button/dist/styles/ToggleTooltipBoxStyled.js
// module id = 872
// module chunks = 0